function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Svg } from 'app/components/icons/svgStyle';
import { SvgIcon } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from '@fupa/fupa-uikit';
const Emblem = _ref => {
  let {
    className,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    "data-testid": "emblem-icon",
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "Emblem",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.29 3.98c-4.65-.44-8.45-2.92-9.7-3.83a.75.75 0 0 0-.88 0c-1.25.91-5.05 3.39-9.7 3.83-.56.05-.99.51-1 1.08-.06 3.67.53 16.13 10.86 18.91.18.04.37.04.56 0C22.75 21.19 23.34 8.73 23.29 5.06c-.01-.57-.44-1.03-1-1.08z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
const Football = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Football",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.16 10.14L16.37 5.54L12.46 1.89L6.99 3.85L7.17 9L13.16 10.14Z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.07 19.47L14.02 22.54L19.16 20.34L20 15.8L14.89 15.17L11.07 19.47Z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.57 0.27L15.79 0.61L16.95 1.07L18.05 1.64L19.09 2.31L20.04 3.09L20.91 3.96L21.68 4.91L22.36 5.94L22.93 7.04L23.39 8.21L23.72 9.42L23.93 10.69L24 12L23.93 13.31L23.72 14.57L23.39 15.79L22.93 16.95L22.36 18.05L21.68 19.09L20.91 20.04L20.04 20.91L19.09 21.68L18.05 22.36L16.95 22.93L15.79 23.39L14.57 23.72L13.31 23.93L12 24L10.99 23.96L10.01 23.83L9.05 23.63L8.12 23.36L7.23 23.01L6.37 22.6L5.55 22.12L4.78 21.58L4.05 20.98L3.37 20.33L2.74 19.63L2.17 18.88L1.66 18.08L1.21 17.25L0.82 16.37L0.76 16.29L0.76 16.21L0.67 15.95L0.58 15.68L0.49 15.41L0.42 15.14L0.34 14.87L0.28 14.59L0.22 14.31L0.17 14.03L0.12 13.75L0.09 13.46L0.05 13.17L0.03 12.88L0.01 12.59L0 12.29L0 12L0.07 10.69L0.27 9.42L0.61 8.21L1.07 7.04L1.64 5.94L2.31 4.91L3.09 3.96L3.96 3.09L4.91 2.31L5.94 1.64L7.04 1.07L8.21 0.61L9.42 0.27L10.69 0.07L12 0L13.31 0.07L14.57 0.27ZM10.96 0.67L10.45 0.73L9.95 0.81L9.46 0.91L8.97 1.03L8.49 1.18L8.02 1.34L7.57 1.53L7.12 1.73L6.68 1.95L6.25 2.19L5.83 2.45L5.43 2.72L5.04 3.01L4.3 4.19L1.46 7.71L1.36 7.98L1.26 8.25L1.17 8.52L1.08 8.8L1.01 9.08L0.94 9.36L0.87 9.64L0.81 9.93L0.76 10.22L0.72 10.51L0.69 10.8L0.66 11.1L0.64 11.4L0.63 11.7L0.62 12L0.62 12.14L0.63 12.29L0.63 12.43L0.64 12.58L0.65 12.72L0.66 12.86L0.67 13.01L0.68 13.15L0.7 13.29L0.72 13.43L0.73 13.57L0.76 13.71L0.78 13.85L0.8 13.99L0.83 14.13L0.9 11.71L4.2 12.84L6.31 18.27L4.1 20.17L4.52 20.56L4.96 20.92L5.41 21.26L5.89 21.58L6.38 21.88L6.88 22.15L7.4 22.4L7.94 22.62L8.48 22.82L9.04 22.98L9.61 23.12L10.2 23.23L10.79 23.31L11.39 23.36L12 23.37L13.21 23.31L14.39 23.12L15.53 22.81L16.61 22.39L17.64 21.87L18.61 21.25L19.5 20.54L20.32 19.74L21.06 18.86L21.71 17.92L22.26 16.9L22.7 15.83L23.04 14.71L23.26 13.54L23.36 12.34L22.19 12.04L20.35 6.85L20.82 4.82L20.57 4.53L20.32 4.25L20.05 3.98L19.78 3.71L19.5 3.45L19.21 3.21L18.91 2.97L18.6 2.74L18.29 2.53L17.97 2.32L17.64 2.13L17.3 1.94L16.96 1.77L16.61 1.6L16.25 1.45L13.46 1.1L12.19 0.63L12.17 0.63L12.16 0.63L12.15 0.63L12.12 0.63L12.07 0.63L12.05 0.62L12.04 0.62L12.02 0.62L12.01 0.62L12 0.62L11.48 0.64L10.96 0.67Z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const PenaltyMissed = _ref2 => {
  let {
    className,
    style
  } = _ref2;
  return /*#__PURE__*/React.createElement(Svg, {
    style: style,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-sentry-element": "Svg",
    "data-sentry-component": "PenaltyMissed",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "fill-rule": "evenodd",
    "data-sentry-element": "g",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0021B",
    d: "m13.159 10.17 3.13-4.652-3.97-3.575L6.897 4l.021.418 5.438 5.612z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.452 19.49a12.015 12.015 0 0 0 2.56-7.656C23.897 5.22 18.442-.049 11.826.066a11.924 11.924 0 0 0-6.85 2.298c-.012.009 5.48 5.717 16.476 17.125ZM5.409 2.831A11.284 11.284 0 0 1 11.837.69c.063-.001.125.001.188.001l1.275.444 2.8.308a11.408 11.408 0 0 1 4.612 3.285l-.43 2.033 1.926 5.143 1.177.277a11.305 11.305 0 0 1-2.395 6.831",
    fill: "#C00",
    "fill-rule": "nonzero",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "m19.75 17.706.336-2.012-2.513-.264z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C00",
    "data-sentry-element": "g",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.159 8.297.025.714.682.13zM11.076 19.457l2.939 3.062 4.753-2.031-4.521-4.601z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.198 2.91A11.952 11.952 0 0 0 .021 12c0 1.481.27 2.9.763 4.209l-.003.08.065.078C2.592 20.822 6.926 23.98 12 23.98c3.483 0 6.62-1.487 8.808-3.86M.646 12c0-1.513.3-2.957.839-4.278l2.833-3.516L20.35 19.59a.866.866 0 0 1-.097.141c-2.076 2.264-4.946 3.624-8.253 3.624-3.061 0-5.84-1.22-7.885-3.196l2.204-1.893-2.104-5.42-3.29-1.134-.076 2.417c-.132-.69-.203-1.4-.203-2.128Z",
    "fill-rule": "nonzero",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.39 22.03 2.235 2.18",
    stroke: "#C00",
    "stroke-width": "2",
    "stroke-linecap": "square",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const FootballShoe = _ref3 => {
  let {
    className,
    style
  } = _ref3;
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "FootballShoe",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.02 15.8c-.33 0-.61 0-.89.02.02.15.25 1.41.28 1.56.01.07.07.11.14.11h1.38c.07 0 .12-.04.14-.11.03-.16.29-1.42.32-1.58h-.25c-.16.01-.32.01-.5 0h-.62zM16.85 17.52h1.39c.06 0 .12-.05.13-.11.03-.16.28-1.38.31-1.53-.61.02-1.38.05-2.22.07.01.1.1.58.26 1.46.04.07.09.11.13.11zM6.11 17.73h1.38c.07 0 .12-.04.14-.11.03-.14.26-1.28.29-1.42-.88.02-1.63.03-2.2.04.02.09.1.55.25 1.38.05.08.09.11.14.11zM2.8 17.62c.01.07.07.11.14.11h1.38c.07 0 .12-.04.14-.11.03-.14.25-1.24.28-1.38-.74-.04-1.51-.18-2.22-.42-.02.04-.03.07-.03.11 0 0 .28 1.52.31 1.69zM17.93 3.76h.03l.03.01.02.01.03.01.02.01.02.01.03.02.02.02.02.01.02.02.02.03 1.1 1.47.09.23-.02.23-.13.23-.21.23-.27.22-.31.22-.32.21-.32.2-.29.18-.25.16-.18.14-.09.13.03.09.06.06.07.05.09.05.1.05.11.05.13.04.13.05.15.03.15.03.16.03.18.02.18.01.19.01h.1l.11-.01.12-.01.11-.01.12-.01.12-.02.12-.02.12-.02.12-.03.12-.03.13-.04.12-.04.13-.04.24-.12.21-.15.17-.18.15-.2.12-.21.1-.21.09-.21.09-.2.08-.18.08-.15.08-.12.1-.08.12-.03.04.01.04.01.05.01.05.03.06.03.06.04.06.05.07.06.07.07.07.08.08.08.09.1.08.11.33.47.26.5.22.53.16.56.13.57.08.58.06.59.04.58.01.58v.56l-.01.54-.01.52-.01.48-.02.3-.03.25-.06.22-.08.18-.1.15-.12.12-.14.1-.16.07-.18.05-.2.04-.23.02-.24.01-.26.01h-.24l-.08-.01H20.53l-.08.01H20.23l-.08.01h-.07l-.53.03-.82.03-1.05.04-1.25.04-1.39.04-1.47.05-1.51.04-1.5.04-1.43.04-1.32.03-1.15.03-.94.02h-.66l-.53-.02-.53-.06-.54-.1-.53-.14-.52-.17-.49-.21-.45-.24-.41-.27-.36-.29-.29-.33-.22-.35-.14-.38-.05-.4.06-.38.15-.32.25-.27.32-.23.39-.2.45-.18.48-.16.52-.15.54-.15.54-.16.54-.18.53-.21.5-.23.5-.25.54-.24.56-.22.58-.2.57-.18.55-.16.52-.15.48-.12.43-.1.35-.09.27-.05.17-.04.06-.01.06-.15.08-.13.09-.11.11-.09.12-.08.12-.06.13-.05.13-.03.12-.03.11-.02.11-.01H12.32l.07-.17.11-.15.14-.13.16-.1.17-.08.18-.06.17-.05.17-.04.16-.02.13-.01.1-.01H13.97l3.69-2.71.02-.01.01-.01.02-.01.02-.01.01-.01.02-.01h.02l.01-.01h.04l.02-.01h.06l.02.01zM8.71 9.91l-.06.04-.03.06v.07l.04.06 4.01 3.68.02.01.02.01.03.01h1.87l.08-.02.05-.07.01-.07-.04-.07-4.47-4.05-.03-.02-.03-.01-.03-.01-.04.01-1.4.37zm2.67-.87l-.06.04-.04.06.01.07.04.06 4.98 4.52.02.01.02.01.02.01h.03l.38.01.66.01h.63l.28.01.08-.03.04-.06.01-.08-.04-.07-5.54-4.92-.03-.02-.03-.01h-.06l-1.4.38z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
const Tracktics = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Tracktics",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M1.72 9.096a.497.497 0 0 0-.496.497.49.49 0 0 0 .496.487.495.495 0 0 0 .496-.487.497.497 0 0 0-.496-.497M5.81 9.096a.497.497 0 0 0-.496.497.49.49 0 0 0 .496.487.488.488 0 0 0 .488-.487.484.484 0 0 0-.488-.497M18.09 9.096a.49.49 0 0 0-.488.497.488.488 0 1 0 .976 0 .484.484 0 0 0-.488-.497M22.18 9.096a.49.49 0 0 0-.487.497.488.488 0 1 0 .975 0 .484.484 0 0 0-.488-.497M1.72 13.187a.497.497 0 0 0-.496.496.49.49 0 0 0 .496.488.495.495 0 0 0 .496-.488.497.497 0 0 0-.496-.496M5.81 13.187a.497.497 0 0 0-.496.496.49.49 0 0 0 .496.488.488.488 0 0 0 .488-.488.484.484 0 0 0-.488-.496M18.09 13.187a.49.49 0 0 0-.488.496.488.488 0 1 0 .976 0 .484.484 0 0 0-.488-.496M22.18 13.187a.49.49 0 0 0-.487.496.488.488 0 1 0 .975 0 .484.484 0 0 0-.488-.496M1.72 17.286a.497.497 0 0 0-.496.496.49.49 0 0 0 .496.488.495.495 0 0 0 .496-.488.497.497 0 0 0-.496-.496M5.81 17.286a.497.497 0 0 0-.496.496.49.49 0 0 0 .496.488.488.488 0 0 0 .488-.488.484.484 0 0 0-.488-.496M18.09 17.286a.49.49 0 0 0-.488.496.488.488 0 1 0 .976 0 .484.484 0 0 0-.488-.496M22.18 17.286a.49.49 0 0 0-.487.496.488.488 0 1 0 .975 0 .484.484 0 0 0-.488-.496M1.72 21.376a.495.495 0 0 0-.496.488.49.49 0 0 0 .496.488.495.495 0 0 0 .496-.488.495.495 0 0 0-.496-.488M5.81 21.376a.495.495 0 0 0-.496.488.49.49 0 0 0 .496.488.488.488 0 0 0 .488-.488.482.482 0 0 0-.488-.488M18.09 21.376a.488.488 0 1 0 .488.488.482.482 0 0 0-.488-.488M22.18 21.376a.488.488 0 1 0 .488.488.482.482 0 0 0-.488-.488M1.72 0A1.41 1.41 0 0 0 .317 1.403c0 .77.633 1.404 1.403 1.404a1.41 1.41 0 0 0 1.403-1.404C3.123.633 2.5 0 1.72 0M5.81 0a1.41 1.41 0 0 0-1.403 1.403c0 .77.633 1.404 1.403 1.404a1.41 1.41 0 0 0 1.404-1.404C7.214.633 6.589 0 5.81 0M9.91 0a1.41 1.41 0 0 0-1.404 1.403c0 .77.633 1.404 1.403 1.404a1.41 1.41 0 0 0 1.404-1.404A1.41 1.41 0 0 0 9.909 0M14 0a1.41 1.41 0 0 0-1.404 1.403c0 .77.634 1.404 1.404 1.404a1.41 1.41 0 0 0 1.403-1.404C15.403.633 14.778 0 14 0M18.099 0a1.41 1.41 0 0 0-1.404 1.403c0 .77.633 1.404 1.404 1.404a1.41 1.41 0 0 0 1.403-1.404A1.415 1.415 0 0 0 18.099 0M22.189 2.807a1.41 1.41 0 0 0 1.403-1.404A1.41 1.41 0 0 0 22.19 0a1.41 1.41 0 0 0-1.403 1.403c0 .77.624 1.404 1.403 1.404M1.72 4.09A1.41 1.41 0 0 0 .317 5.494c0 .77.633 1.403 1.403 1.403a1.41 1.41 0 0 0 1.403-1.403c0-.77-.624-1.404-1.403-1.404M5.81 4.09a1.41 1.41 0 0 0-1.403 1.404c0 .77.633 1.403 1.403 1.403a1.41 1.41 0 0 0 1.404-1.403c0-.77-.625-1.404-1.404-1.404M9.91 4.09a1.41 1.41 0 0 0-1.404 1.404c0 .77.633 1.403 1.403 1.403a1.41 1.41 0 0 0 1.404-1.403A1.41 1.41 0 0 0 9.909 4.09M14 4.09a1.41 1.41 0 0 0-1.404 1.404c0 .77.634 1.403 1.404 1.403a1.41 1.41 0 0 0 1.403-1.403c0-.77-.625-1.404-1.403-1.404M9.91 8.19a1.41 1.41 0 0 0-1.404 1.403c0 .77.633 1.403 1.403 1.403a1.41 1.41 0 0 0 1.404-1.403c0-.779-.634-1.404-1.404-1.404M14 10.996a1.41 1.41 0 0 0 1.403-1.403A1.41 1.41 0 0 0 14 8.189a1.41 1.41 0 0 0-1.404 1.404c0 .77.634 1.403 1.404 1.403M9.91 12.28a1.41 1.41 0 0 0-1.404 1.403c0 .77.633 1.403 1.403 1.403a1.41 1.41 0 0 0 1.404-1.403 1.41 1.41 0 0 0-1.404-1.403M14 12.28a1.41 1.41 0 0 0-1.404 1.403c0 .77.634 1.403 1.404 1.403a1.41 1.41 0 0 0 1.403-1.403c0-.77-.625-1.403-1.403-1.403M9.91 16.379a1.41 1.41 0 0 0-1.404 1.403c0 .77.633 1.403 1.403 1.403a1.41 1.41 0 0 0 1.404-1.403c0-.779-.634-1.403-1.404-1.403M14 16.379a1.41 1.41 0 0 0-1.404 1.403c0 .77.634 1.403 1.404 1.403a1.41 1.41 0 0 0 1.403-1.403c0-.779-.625-1.403-1.403-1.403M9.91 20.469a1.41 1.41 0 0 0-1.404 1.403c0 .77.633 1.404 1.403 1.404a1.41 1.41 0 0 0 1.404-1.404 1.41 1.41 0 0 0-1.404-1.403M14 20.469a1.41 1.41 0 0 0-1.404 1.403c0 .77.634 1.404 1.404 1.404a1.41 1.41 0 0 0 1.403-1.404c0-.77-.625-1.403-1.403-1.403M18.099 4.09a1.41 1.41 0 0 0-1.404 1.404c0 .77.633 1.403 1.404 1.403a1.41 1.41 0 0 0 1.403-1.403 1.415 1.415 0 0 0-1.403-1.404M22.189 4.09a1.41 1.41 0 0 0-1.403 1.404c0 .77.633 1.403 1.403 1.403a1.41 1.41 0 0 0 1.403-1.403A1.41 1.41 0 0 0 22.19 4.09",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const Card = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Card",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06 23.98c-.49.1-.89-.2-.99-.59-.5-1.89-4.54-17.02-5.05-18.92-.1-.49.2-.89.6-.99C3.9 3.14 14.2.37 15.49.02c.5-.1.89.2.99.59.51 1.88 4.55 16.93 5.05 18.82.2.49-.1.99-.59 1.09-2.58.69-11.59 3.11-12.88 3.46z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const RedCard = styled(Card).withConfig({
  componentId: "sc-w231r-0"
})(["color:", ";"], COLORS.red);
const YellowCard = styled(Card).withConfig({
  componentId: "sc-w231r-1"
})(["color:", ";"], COLORS.yellowCard);
const TwoCards = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "TwoCards",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8D94D",
    d: "M6.06 23.98c-.49.1-.89-.2-.99-.59C4.57 21.5.53 6.37.02 4.47c-.1-.49.2-.89.6-.99 0 0 18.912 16.02 18.91 15.95.2.49-.1.99-.59 1.09-2.58.69-11.59 3.11-12.88 3.46z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "M.62 3.48C1.9 3.14 12.2.37 13.49.02c.5-.1.89.2.99.59.51 1.88 4.55 16.93 5.05 18.82C19.53 19.587.62 3.48.62 3.48z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const SubstitutionInOut = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "SubstitutionInOut",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "M13.27 18.57L11.55 18.57L9.79 18.57L12.52 21.27L15.22 24L17.92 21.27L20.64 18.57L18.89 18.57L17.17 18.57L17.17 13.29L17.17 8L15.22 8L13.27 8L13.27 13.29L13.27 18.57Z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#859E11",
    d: "M11.37 5.43L13.1 5.43L14.85 5.43L12.12 2.73L9.43 0L6.73 2.73L4 5.43L5.75 5.43L7.48 5.43L7.48 10.71L7.48 16L9.43 16L11.37 16L11.37 10.71L11.37 5.43Z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const ArrowDown = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "ArrowDown",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22 15.87H4l4.09 4.04L12.14 24l4.05-4.09 4.09-4.04h-5.22V0H9.22V15.87z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const RotatedSvgIcon = styled(SvgIcon).withConfig({
  componentId: "sc-w231r-2"
})(["transform:rotate(180deg);"]);
const ArrowUp = props => {
  return /*#__PURE__*/React.createElement(RotatedSvgIcon, _extends({}, props, {
    "data-sentry-element": "RotatedSvgIcon",
    "data-sentry-component": "ArrowUp",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22 15.87H4l4.09 4.04L12.14 24l4.05-4.09 4.09-4.04h-5.22V0H9.22V15.87z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const SubstitutionIn = styled(ArrowUp).withConfig({
  componentId: "sc-w231r-3"
})(["color:", ";"], COLORS.green);
const SubstitutionOut = styled(ArrowDown).withConfig({
  componentId: "sc-w231r-4"
})(["color:", ";"], COLORS.red);
const New = _ref4 => {
  let {
    className,
    style
  } = _ref4;
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 11",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "New",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.732 10V.28h1.236l2.364 5.544V.28h1.464V10H4.62L2.244 4.192V10H.732Zm6.54 0V.28h4.08v1.248H9.048v2.796h1.812V5.56H9.048v3.216h2.328V10H7.272Zm7.8.132c-.72 0-1.28-.132-1.68-.396-.4-.264-.676-.64-.828-1.128-.152-.488-.228-1.072-.228-1.752V.28h1.728v6.78c0 .304.02.59.06.858.04.268.134.484.282.648.148.164.37.246.666.246.312 0 .538-.082.678-.246a1.3 1.3 0 0 0 .276-.648c.044-.268.066-.554.066-.858V.28h1.716v6.576c0 .68-.076 1.264-.228 1.752-.152.488-.426.864-.822 1.128-.396.264-.958.396-1.686.396Z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
const FuPaTv = _ref5 => {
  let {
    className,
    style
  } = _ref5;
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "FuPaTv",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.1 10.41c-.07.52-.1 1.04-.1 1.58 0 2.32.65 4.49 1.79 6.32 2.12 3.4 5.9 5.68 10.21 5.68 6.62 0 12-5.37 12-12C24 5.37 18.62 0 12 0 5.9 0 .87 4.53.1 10.41z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.36 7.87l.52-2.71-3.04.82-.37 1.88h-1.3l-.41 2.26h1.27c-.46 2.4-.71 3.72-.76 3.99-.16.76-.23 1.31-.23 1.85 0 1.28.85 2.18 2.63 2.18.62 0 1.36-.09 1.75-.23.03-.23.29-2.09.33-2.32-.25.04-.56.04-.81.04-.66 0-.86-.35-.86-.84 0-.35.08-.87.16-1.28.05-.23.27-1.36.68-3.39h2.15l-.38-2.26H9.36v.01zM15.93 12.29c-.55 1.23-.86 1.99-1.13 2.71h-.06c-.06-.73-.16-1.5-.27-2.73-.03-.29-.19-1.76-.47-4.4h-3.05l.38 2.26 1.31 7.79h3.02l5.6-10.05h-3.31c-1.21 2.65-1.88 4.12-2.02 4.42z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
const GalleryAndTv = _ref6 => {
  let {
    className,
    style
  } = _ref6;
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "GalleryAndTv",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.86 12.14c.6.583 1.314.874 2.14.874.826 0 1.535-.296 2.127-.887.591-.592.887-1.3.887-2.127 0-.826-.296-1.535-.887-2.127A2.901 2.901 0 0 0 6 6.986c-.826 0-1.535.296-2.127.887A2.901 2.901 0 0 0 2.986 10c0 .826.291 1.54.873 2.14zM4.196 4h3.606L8.9 5.183h1.916c.32 0 .596.122.83.366.236.244.353.526.353.845v7.212c0 .319-.117.6-.352.845a1.116 1.116 0 0 1-.831.366H1.183c-.32 0-.596-.122-.83-.366A1.183 1.183 0 0 1 0 13.606V6.394c0-.319.117-.6.352-.845.235-.244.512-.366.831-.366H3.1L4.197 4zm.45 7.352A1.844 1.844 0 0 1 4.086 10c0-.526.187-.977.563-1.352A1.844 1.844 0 0 1 6 8.085c.526 0 .977.187 1.352.563.376.375.563.826.563 1.352 0 .526-.187.977-.563 1.352A1.844 1.844 0 0 1 6 11.915c-.526 0-.977-.187-1.352-.563z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.001.008a5.993 5.993 0 1 0 0 11.984 5.993 5.993 0 1 0 0-11.984z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.687 3.942l.258-1.357-1.518.41-.186.944h-.647l-.206 1.128h.635l-.38 1.991c-.081.38-.114.656-.114.925 0 .638.422 1.087 1.314 1.087.308 0 .677-.042.871-.114l.165-1.158c-.123.02-.279.02-.401.02-.33 0-.432-.173-.432-.421 0-.174.042-.431.081-.638l.339-1.695h1.071l-.188-1.128h-.662v.006zM18.974 3.942l-1.006 2.206c-.278.617-.43.997-.565 1.356h-.03c-.03-.368-.081-.748-.135-1.365l-.237-2.197h-1.52l.188 1.128.653 3.89h1.509l2.796-5.018h-1.653z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
const Coach = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Coach",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7 16.16l1.9-3.01-2.9-1.3-.9 1.3 1.9 3.01zM12.59 13.15l1.9 3.01 1.9-3.01-.9-1.3-2.9 1.3z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.83 13.39l.07.02.07.03.07.03.07.03.07.04.06.04.07.04.06.05.06.04.06.05.06.06.05.05.06.06v.01l.02.02.01.01.02.02.01.01.02.02.01.02.02.02.01.02.02.02.01.02.02.01.02.04.03.03.02.04.02.04.03.03.02.04.02.04.02.04.02.04.02.04.02.04.02.04.01.04.02.04 3.09 8.44.03.1.02.1v.19l-.02.09-.04.08-.04.07-.05.06-.07.06-.07.05-.08.04-.1.03-.1.01-.11.01h-8.13l.11-.13-.2-1.09L12.12 24H2.68l-.11-.01-.1-.01-.09-.03-.08-.04-.08-.05-.06-.06-.05-.06-.05-.07-.03-.08-.02-.09-.01-.09.01-.1.02-.1.03-.1 3.09-8.44.01-.04.02-.04.02-.04.02-.04.02-.04.02-.04.02-.04.02-.04.02-.04.03-.04.02-.04.03-.03.02-.04.03-.04.01-.01.01-.02.01-.02.02-.01.01-.02.02-.02.02-.02.01-.01.01-.02.01-.01.01-.01.01-.01.01-.01.05-.06.06-.05.06-.05.06-.06.06-.04.06-.05.06-.04.07-.04.07-.04.06-.03.07-.03.08-.03.07-.02.07-.02.54-.06h.49v.02l.01.02v.03l.01.01v.02l.01.01v.01l1.68 2.64.22.36.02.02.01.01.02.02.01.01.02.02.02.01.01.01.02.01.02.01.02.01h.04l.03.01h.04l.02-.01h.04l.02-.01.02-.01.02-.01.02-.01.02-.01.02-.02.01-.01.02-.02.01-.01.01-.02.96-1.51-.23 1.03 1.12 1.91-.44 2.34 1.25-1.23-.21-1.11 1.13-1.91-.22-.94.9 1.42.01.02.02.01.01.02.02.01.01.02.02.01.02.01.02.01.02.01.02.01h.04l.02.01h.05l.02-.01h.04l.02-.01.02-.01.02-.01.02-.01.01-.01.02-.02.02-.01.01-.02.02-.01.01-.02L16.28 14l.37-.57v-.01l.01-.01v-.02h.01v-.04l.01-.03v-.01h.54l.53.06.08.02zm-7.12 10.48l.1.12 2.34-2.31-.3-1.61-1.76 1.73-.38 2.07zM8.62 2.09c.48-.12.75.06 1.09.29.65.42 1.85 1.21 6.37 1.09h.14c.04.06.06.1.07.11.03.05.85 1.31.96 4.4.15-.12.33-.3.49-.54.12-.47.19-.96.19-1.46 0-3.2-2.51-5.8-5.67-5.96V0c-.06 0-.11.01-.16.01S11.99 0 11.94 0v.02a5.966 5.966 0 0 0-5.67 5.96c0 .45.05.89.15 1.31.32.46.72.89 1.11 1-.07-1.69-.12-5.91 1.09-6.2z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 8.78c-.01-.22-.01-.34-.01-.37-.04-2.72-.64-4.08-.84-4.46-4.56.1-5.82-.73-6.5-1.18-.31-.2-.44-.28-.72-.22-.61.15-.85 3.22-.72 5.99.01.01.01.09.02.23-.14.01-.22.01-.24.02h-.07c-.33 0-.65-.16-.93-.38.89 2 2.85 3.42 5.15 3.54v.01h.31v-.01a5.98 5.98 0 0 0 5.12-3.47c-.13.09-.23.14-.24.14-.05.03-.16.08-.33.16z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const Whistle = _ref7 => {
  let {
    className,
    style
  } = _ref7;
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "Whistle",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.488 3.764l-6.74 3.51a.721.721 0 0 0-.033.484 5.398 5.398 0 0 1-.981 4.739 5.55 5.55 0 0 1-2.943 1.938c-2.6.697-5.254-.558-6.374-2.858-2.62 1.246-2.762-2.25-.522-1.76l.016-.001c-.281-2.522 1.262-4.95 3.747-5.777l-.005-.015.325-.087 1.643-.44 2.493-.668L17.34.893l2.148 2.871z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
const Eleven = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Eleven",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.776,8.64 C8.65866608,8.70400032 8.34933584,8.8426656 7.848,9.056 C7.76266624,9.08800016 7.62933424,9.14133296 7.448,9.216 C7.26666576,9.29066704 7.11733392,9.35999968 7,9.424 L7,7.44 C8.2800064,6.77866336 9.06399856,6.29866816 9.352,6 L11.448,6 L11.448,18.96 L8.776,18.96 L8.776,8.64 Z M13.72,8.64 C13.6026661,8.70400032 13.2933358,8.8426656 12.792,9.056 C12.7066662,9.08800016 12.5733342,9.14133296 12.392,9.216 C12.2106658,9.29066704 12.0613339,9.35999968 11.944,9.424 L11.944,7.44 C13.2240064,6.77866336 14.0079986,6.29866816 14.296,6 L16.392,6 L16.392,18.96 L13.72,18.96 L13.72,8.64 Z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const FormStanding = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "FormStanding",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42 17.72l.17.23 1.1 1.53 4.37-6.07 1.76 2.45c2.05-2.85 3.19-4.43 3.41-4.74.29-.4.2-.95-.2-1.24a.884.884 0 0 0-1.23.21c-.13.18-.79 1.1-1.98 2.75l-.11-.16-1.65-2.29-4.37 6.07-1.27-1.76-2.66 3.7V1.56H0v19.99h21.75v-1.76H2.94l.95-1.33.53-.74zM21.4.72l1.06.82.82 1.06.53 1.25.19 1.39-.19 1.39-.53 1.25-.82 1.06-1.06.81-1.25.53-1.39.19-1.39-.19-1.25-.53-1.06-.81-.81-1.06-.53-1.25-.19-1.39.19-1.39.53-1.25.81-1.06 1.06-.82 1.25-.53L18.76 0l1.39.19 1.25.53zm-3.36 1.12l-.34.09-.33.13.06.13.04.15.03.15.01.16-.11.51-.28.43-.43.29-.52.1-.15-.01-.15-.03-.15-.04-.13-.06-.13.33-.09.34-.06.36-.02.36.02.37.06.36.09.34.13.33.13-.06.15-.04.15-.03.15-.01.52.1.43.29.28.42.11.52-.01.16-.03.15-.04.14-.06.14.33.13.34.09.36.06.36.02.37-.02.36-.06.34-.09.33-.13-.06-.13-.04-.15-.03-.15-.01-.16.1-.52.29-.42.42-.29.52-.1.16.01.15.03.14.04.14.06.13-.33.09-.34.06-.36.02-.37-.02-.36-.06-.36-.09-.34-.13-.33-.14.06-.14.04-.15.03-.16.01-.52-.1-.42-.29-.29-.43-.1-.51.01-.16.03-.15.04-.15.06-.13-.33-.13-.34-.09-.36-.06-.37-.02-.36.02-.36.06z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.76 6.57a1.336 1.336 0 0 1 0-2.67c.74 0 1.34.6 1.34 1.34 0 .73-.6 1.33-1.34 1.33z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const Leaderboard = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Leaderboard",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,21H2V9h5.5V21z M14.75,3h-5.5v18h5.5V3z M22,11h-5.5v10H22V11z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const Ban = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Ban",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.86.02l.1.03.09.04.09.05.08.05.07.07.07.08.05.09.05.09 7.22 17.45.03.1.02.1.01.1v.1l-.02.1-.02.09-.04.09-.05.09-.06.08-.07.08-.07.06-.09.06-.1.04-11.84 4.9-.06.03-.07.01H10.1l-.08-.02-.08-.02-.09-.04-.09-.04-.09-.06-.09-.06-.09-.08-.1-.08-.1-.09L2.07 6.07l-.04-.1-.02-.11-.01-.1.01-.1.01-.1.03-.09.04-.09.05-.09.05-.08.07-.07.08-.07.09-.06.09-.04L14.36.07l.1-.04.1-.02.11-.01.1.01.09.01zM7.07 8.27l-.9 2.25 4.63 1.85L8.95 17l2.24.9 1.86-4.63 4.63 1.86.9-2.25-4.64-1.85L15.8 6.4l-2.24-.9-1.86 4.63-4.63-1.86z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const TopEleven = _ref8 => {
  let {
    className,
    style
  } = _ref8;
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "TopEleven",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#44B5BC",
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM8.584 7.68V18h2.672V5.04H9.16c-.288.299-1.072.779-2.352 1.44v1.984c.117-.064.267-.133.448-.208.181-.075.315-.128.4-.16.501-.213.81-.352.928-.416zm4.944 0V18H16.2V5.04h-2.096c-.288.299-1.072.779-2.352 1.44v1.984c.117-.064.267-.133.448-.208.181-.075.315-.128.4-.16.501-.213.81-.352.928-.416z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
const Assist = props => {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    "data-sentry-element": "SvgIcon",
    "data-sentry-component": "Assist",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "data-sentry-element": "svg",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.57.27l1.22.34 1.16.45 1.1.57 1.03.68.96.78.86.86.78.96.68 1.03.57 1.1.45 1.16.34 1.22.2 1.27L24 12l-.08 1.3-.2 1.27-.34 1.22-.45 1.16-.57 1.1-.68 1.03-.78.96-.86.86-.96.78-1.03.68-1.1.57-1.16.45-1.22.34-1.27.2L12 24l-1.31-.08-1.27-.2-1.22-.34-1.16-.45-1.1-.57-1.03-.68-.96-.78-.86-.86-.78-.96-.68-1.03-.57-1.1-.45-1.16-.34-1.22-.2-1.27L0 12l.07-1.31.2-1.27.34-1.22.45-1.16.57-1.1.68-1.03.78-.96.86-.86.96-.78 1.03-.68 1.1-.57L8.2.61 9.42.27l1.27-.2L12 0l1.3.07 1.27.2zm-2.81 2.59l-.11.02-.11.04-.11.05-.1.05-.1.06-.09.08-.08.08-.08.09-.07.09-7.86 12-.09.17-.07.18-.04.18-.01.18.01.18.04.17.06.17.08.17.11.14.13.14.15.12.17.09.17.06.18.04.19.02.18-.02.17-.03.17-.06.16-.09.15-.11.14-.13.11-.15 1.91-2.91h9.75l1.91 2.91.07.1.08.09.08.08.1.08.09.06.11.05.1.05.11.03.11.03.12.01.11.01h.07l.06-.01.07-.01.07-.01.06-.02.07-.02.06-.02.06-.02.07-.03.06-.04.06-.03.15-.12.13-.14.11-.14.08-.16.06-.18.04-.17.01-.18-.01-.18-.04-.18-.07-.18-.09-.17-7.86-12-.07-.09-.08-.09-.08-.08-.09-.08-.1-.06-.1-.05-.11-.05-.11-.04-.11-.02-.12-.02H11.88l-.12.02z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8 11.3h6.4L12 6.5l-3.2 4.8z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  })));
};
const GoogleCalendar = _ref9 => {
  let {
    className,
    style
  } = _ref9;
  return /*#__PURE__*/React.createElement(Svg, {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "186 38 76 76",
    style: style,
    "data-sentry-element": "Svg",
    "data-sentry-component": "GoogleCalendar",
    "data-sentry-source-file": "icons.tsx"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M244 56h-40v40h40V56z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M244 114l18-18h-18v18z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M262 56h-18v40h18V56z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M244 96h-40v18h40V96z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M186 96v12c0 3.315 2.685 6 6 6h12V96h-18z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M262 56V44c0-3.315-2.685-6-6-6h-12v18h18z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M244 38h-52c-3.315 0 -6 2.685-6 6v52h18V56h40V38z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M212.205 87.03c-1.495-1.01-2.53-2.485-3.095-4.435l3.47-1.43c.315 1.2.865 2.13 1.65 2.79.78.66 1.73.985 2.84.985 1.135 0 2.11-.345 2.925-1.035s1.225-1.57 1.225-2.635c0-1.09-.43-1.98-1.29-2.67-.86-.69-1.94-1.035-3.23-1.035h-2.005V74.13h1.8c1.11 0 2.045-.3 2.805-.9.76-.6 1.14-1.42 1.14-2.465 0 -.93-.34-1.67-1.02-2.225-.68-.555-1.54-.835-2.585-.835-1.02 0 -1.83.27-2.43.815a4.784 4.784 0 0 0 -1.31 2.005l-3.435-1.43c.455-1.29 1.29-2.43 2.515-3.415 1.225-.985 2.79-1.48 4.69-1.48 1.405 0 2.67.27 3.79.815 1.12.545 2 1.3 2.635 2.26.635.965.95 2.045.95 3.245 0 1.225-.295 2.26-.885 3.11-.59.85-1.315 1.5-2.175 1.955v.205a6.605 6.605 0 0 1 2.79 2.175c.725.975 1.09 2.14 1.09 3.5 0 1.36-.345 2.575-1.035 3.64s-1.645 1.905-2.855 2.515c-1.215.61-2.58.92-4.095.92-1.755.005-3.375-.5-4.87-1.51zM233.52 69.81l-3.81 2.755-1.905-2.89 6.835-4.93h2.62V88h-3.74V69.81z",
    "data-sentry-element": "path",
    "data-sentry-source-file": "icons.tsx"
  }));
};
export { Emblem, Football, PenaltyMissed, FootballShoe, Tracktics, Card, YellowCard, RedCard, TwoCards, SubstitutionInOut, ArrowDown, SubstitutionOut, ArrowUp, SubstitutionIn, New, FuPaTv, GalleryAndTv, Coach, Whistle, Eleven, FormStanding, Leaderboard, Ban, TopEleven, Assist, GoogleCalendar };